import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import ProtectedRoute from "@/lib/ProtectedRoute";
import AuthCallback from "@/lib/AuthCallback";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import EventDetail from "@/pages/EventDetail";
import MyEvents from "@/pages/MyEvents";
import MemberEventView from "@/pages/MemberEventView";
import Scanner from "@/pages/Scanner";
import Ledger from "@/pages/Ledger";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import PublicEvent from "@/pages/PublicEvent";
import MemberShareLink from "@/pages/MemberShareLink";

function RootRouter() {
  const location = useLocation();
  if (typeof window !== "undefined" && (location.hash || "").includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/e/:eventId" element={<PublicEvent />} />
      <Route path="/m/:token" element={<MemberShareLink />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/events/:eventId" element={<ProtectedRoute><EventDetail /></ProtectedRoute>} />
      <Route path="/member" element={<ProtectedRoute><MyEvents /></ProtectedRoute>} />
      <Route path="/member/events/:eventId" element={<ProtectedRoute><MemberEventView /></ProtectedRoute>} />
      <Route path="/scanner" element={<ProtectedRoute><Scanner /></ProtectedRoute>} />
      <Route path="/ledger" element={<ProtectedRoute><Ledger /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <RootRouter />
          <Toaster richColors position="bottom-right" theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
